import { whyConsult } from "@/data/content";
import { SectionHeading, Reveal } from "@/components/motion";

export const WhyConsult = () => (
  <section className="bg-navy-900 grain relative py-16 sm:py-24 lg:py-32" data-testid="why-consult-section">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="05"
        eyebrow="Why a Physician"
        title="Why Choose a Physician Consultation?"
        sub="An MD (Internal Medicine) physician is trained to see the whole picture — diagnosing accurately before referring, and managing most adult conditions comprehensively."
        dark
      />
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="why-consult-grid">
        {whyConsult.map((item, i) => (
          <Reveal key={item.title} delay={i % 3}>
            <article
              data-testid={`why-card-${item.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group h-full rounded-2xl border border-white/10 bg-white/[0.04] p-6 sm:p-7 hover:bg-white/[0.08] hover:border-teal-400/30 hover:-translate-y-1 transition-[transform,background-color,border-color] duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-teal-400/10 border border-teal-400/20 flex items-center justify-center mb-5">
                <item.icon size={20} className="text-teal-300" />
              </div>
              <h3 className="font-serif font-semibold text-white text-xl leading-snug">{item.title}</h3>
              <p className="mt-2.5 text-sm text-slate-300 leading-relaxed">{item.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
